import { MilestonePackageRoute } from 'types';

export const getAfterCompletionRedirectPath = (
  accountId: string,
  packageSegment: MilestonePackageRoute,
  canReview: boolean,
) => {
  return `/accounts/${accountId}/${packageSegment}/${canReview ? 'review' : 'edit'}`;
};
